export default __webpack_public_path__ + "static/media/fireFN31.388acf7e.svg";